<template>


<section class="kc-elm kc-css-110769 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="full" data-ssc-img-anim="none"></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-416531 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-137239 ">
                  <h2 class="wr deb derb dea dera none nonea">
                     <slot name="title">
                        <span class="t1">Website </span><span class="t2"> design</span><span class="t3"> packages</span>
                     </slot>
                  </h2>
               </div>
               <div class="ssc_mltttl  kc-elm kc-css-817106 ">
                  <div class="wr deb derb dea dera none nonea">
                     <slot name="subtitle">
                        <span class="t1">We offer a few standart packages as well as custom projects</span>
                     </slot>
                  </div>
               </div>
               <div class="kc-elm kc-css-972955 kc_row kc_row_inner sst-flex-row-inner">
                  <div class="kc-elm kc-css-731184 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="kc-elm kc-css-541650 kc-pricing-tables kc-pricing-layout-3 wow animated bounceInLeft" data-wow-duration="2s" data-wow-delay="0s">
                           <slot name="comparison1">
                              <div class="content-title">Landing page</div>
                              <ul class="content-desc">
                                 <li><i class="nat-checkmark3"></i> Terms - 3 days
                                 </li>
                                 <li><i class="nat-checkmark3"></i> 5 - 14 blocks
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Responsive design
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Social links
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Video/photo gallery
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Contact form, CTA
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Slider, selling texts
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Analytics integration </li>
                              </ul>
                           </slot>
                           <!-- <div class="kc-pricing-price"><span class="content-currency">from</span><span class="content-price">$  895</span><span class="content-duration">.99</span></div> -->
                           <!-- <div class="content-button"><a href="#">Learn more</a></div> -->
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-227325 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="kc-elm kc-css-470515 kc-pricing-tables kc-pricing-layout-3 wow animated bounceInUp" data-wow-duration="2s" data-wow-delay="0s">
                           <slot name="comparison2">
                              <div class="content-title">Landing page</div>
                              <ul class="content-desc">
                                 <li><i class="nat-checkmark3"></i> Terms - 3 days
                                 </li>
                                 <li><i class="nat-checkmark3"></i> 5 - 14 blocks
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Responsive design
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Social links
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Video/photo gallery
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Contact form, CTA
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Slider, selling texts
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Analytics integration </li>
                              </ul>
                           </slot>
                           <!-- <div class="kc-pricing-price"><span class="content-currency">from</span><span class="content-price">$  895</span><span class="content-duration">.99</span></div>
                           <div class="content-button"><a href="#">Learn more</a></div> -->
                        </div>
                     </div>
                  </div>
                  <div class="kc-elm kc-css-499934 kc_col-sm-4 kc_column_inner kc_col-sm-4">
                     <div class="kc_wrapper kc-col-inner-container">
                        <div class="kc-elm kc-css-546832 kc-pricing-tables kc-pricing-layout-3 wow animated bounceInRight" data-wow-duration="2s" data-wow-delay="0s">
                           <slot name="comparison3">
                              <div class="content-title">Landing page</div>
                              <ul class="content-desc">
                                 <li><i class="nat-checkmark3"></i> Terms - 3 days
                                 </li>
                                 <li><i class="nat-checkmark3"></i> 5 - 14 blocks
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Responsive design
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Social links
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Video/photo gallery
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Contact form, CTA
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Slider, selling texts
                                 </li>
                                 <li><i class="nat-checkmark3"></i> Analytics integration </li>
                              </ul>
                           </slot>
                           <!-- <div class="kc-pricing-price"><span class="content-currency">from</span><span class="content-price">$  895</span><span class="content-duration">.99</span></div>
                           <div class="content-button"><a href="#">Learn more</a></div> -->
                        </div>
                     </div>
                  </div>
               </div>
               <div class="bgrlabel  kc-elm kc-css-83700" style="left:-100px;bottom:-130px;">
                  <div class="inside_wrap">
                     <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Plant.png" alt="" src="../../assets/images/Plant.png"></div>
                  </div>
               </div>
               <div class="bgrlabel  kc-elm kc-css-856953" style="bottom:-100px;right:-130px;">
                  <div class="inside_wrap">
                     <div class="imgl"><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Bamboo.png" alt="" src="../../assets/images/Bamboo.png"></div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>


</template>

<script>
export default {
  name: "Comparison",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Comparison"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-4{width:33.3333%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_row.kc_row_inner{width:calc(100% + 30px);}
.kc_column,.kc_column_inner{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container,.kc_column_inner>.kc-col-inner-container{height:100%;}
.kingcomposer div.kc_column,.kingcomposer div.kc_column_inner{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns,.kc_row_inner{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns,.kc_row_inner{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column,body.kc-css-system .kc_column_inner{width:100%;}
div.kc_row{display:block;}
}
.kc-pricing-tables{transition:all .3s ease 0s;}
.content-title{margin:25px 0 20px;font-size:20px;text-transform:uppercase;font-weight:700;color:#444;}
.content-desc{font-weight:400;margin-bottom:25px;color:rgba(86,86,86,.8);padding:0;}
.content-button a{display:inline-block;padding:7px 20px;text-transform:uppercase;background:#eee;color:#666;font-size:12px;}
.kc-pricing-tables{float:left;width:100%;overflow:hidden;}
.kc-pricing-tables .content-desc li:last-child{margin-left:0!important;margin-top:0!important;margin-right:0!important;}
.kc-pricing-tables .content-desc li:first-child{margin-left:0!important;margin-bottom:0!important;margin-right:0!important;}
.kc-pricing-tables .content-desc li{border-left:0!important;border-right:0!important;list-style:none;}
.kc-pricing-tables .content-desc li:not(:last-child){border-bottom:0!important;}
.kc-pricing-layout-3{float:left;width:100%;line-height:1.4;background:#42BCE2;}
.kc-pricing-layout-3 .kc-pricing-price{float:left;width:100%;text-align:center;padding:10px 0;background:rgba(255,255,255,.15);}
.kc-pricing-layout-3 .kc-pricing-price span{font-weight:300;color:#fff;font-size:60px;}
.kc-pricing-layout-3 .kc-pricing-price span.content-duration{font-size:14px;}
.kc-pricing-layout-3 .content-title{float:left;width:100%;text-align:center;font-size:30px;font-weight:300;color:#fff;margin:0 0 15px;padding:30px 0;background:rgba(255,255,255,.15);text-transform:uppercase;}
.kc-pricing-layout-3 .content-desc{float:left;width:100%;list-style:none;margin:0;text-align:center;}
.kc-pricing-layout-3 .content-desc li{float:left;width:100%;padding:8px 0;font-size:14px;color:#fff;}
.kc-pricing-layout-3 .content-button{float:left;width:100%;text-align:center;}
.kc-pricing-layout-3 .content-button a{display:inline-block;padding:10px 20px;font-size:16px;font-weight:300;margin-top:25px;margin-bottom:25px;background:rgba(255,255,255,.15);color:#fff;}
.kc-pricing-layout-3 .content-button a:hover{background:#fff;color:#42BCE2;}
.kc-pricing-price span{display:inline-block;}
.entry-content a{box-shadow:none;}
.content-button a{transition:all .3s ease 0s;}
[class^="nat-"]{font-family:'native'!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}
.nat-checkmark3:before{content:"\ed71";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
section{display:block;}
img{border:0;max-width:100%;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:center;margin:20px 0 15px 0;}
h3{font-family:"Catamaran";color:#222;font-weight:500;font-size:25px;line-height:32px;text-align:center;margin:20px 0;}
i{font-style:italic;}
ul{margin:0 0 1.5em 1em;}
ul{list-style:disc;}
*,*:before,*:after{box-sizing:inherit;}
.kc_row.kc_row_inner:focus{outline:none;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
.content-button a{text-decoration:none;}
.kc-col-container>div{position:relative;}
.kc-col-container>div.bgrlabel{z-index:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;}
@media screen and (max-width:768px){
ul{margin:0 0 1.5em 1em;}
}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
@media screen and (max-width:540px){
ul{margin:0 0 1.5em 0;}
}
body .bgrlabel{float:none;position:absolute;display:inline-block;width:auto;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
.ssc_mltttl>h2,.ssc_mltttl>h3{display:inline-block;width:auto;position:relative;}
.kc-pricing-tables{position:relative;}
body .kc-pricing-tables .content-title{z-index:3;position:relative;background-color:transparent;}
.kc-pricing-price span{display:inline-block;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
.sst-flex-row-inner{position:relative;z-index:1;min-height:30px;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-731184{width:33.33%;}
body.kc-css-system .kc-css-227325{width:33.33%;}
body.kc-css-system .kc-css-499934{width:33.33%;}
}
body.kc-css-system .kc-css-110769{padding-top:30px;padding-bottom:150px;}
body.kc-css-system .kc-css-137239.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-137239{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-137239 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-137239 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-137239 .t2{color:#ED7D31;}
body.kc-css-system .kc-css-817106.ssc_mltttl .wr{text-align:center;}
body.kc-css-system .kc-css-817106{text-align:center;padding-bottom:33px;display:inline-block;}
body.kc-css-system .kc-css-817106 .deb:before{border-radius:50px 50px 50px 50px;width:40px;height:40px;}
body.kc-css-system .kc-css-817106 .deb:after{border-radius:20px 20px 20px 20px;width:8px;height:8px;margin-top:17px;margin-right:-4px;}
body.kc-css-system .kc-css-541650 .content-title{color:#222222;font-family:Montserrat;font-size:25px;font-weight:700;line-height:25px;text-transform:none;text-align:center;padding-bottom:15px;}
body.kc-css-system .kc-css-541650 .content-price{color:#222222;font-size:35px;font-weight:700;padding-top:15px;}
body.kc-css-system .kc-css-541650 .kc-pricing-price{font-family:Montserrat;text-align:center;}
body.kc-css-system .kc-css-541650 .content-currency{color:#666666;font-size:16px;font-weight:400;line-height:55px;font-family:Montserrat;padding-right:15px;}
body.kc-css-system .kc-css-541650 .kc-pricing-price span.content-duration{color:#222222;font-size:18px;font-weight:700;}
body.kc-css-system .kc-css-541650 .content-desc li{color:#666666;font-family:Catamaran;font-size:17px;font-weight:400;line-height:18px;text-align:center;}
body.kc-css-system .kc-css-541650 .content-button a{color:#222222;background-color:#ffffff;font-size:16px;line-height:25px;font-weight:600;text-transform:none;width:100%;border:2px solid #ED7D31;border-radius:30px 30px 30px 30px;padding-right:60px;padding-left:60px;margin-top:10px;margin-bottom:15px;margin-left:-5px;}
body.kc-css-system .kc-css-541650 .content-button a:hover{color:#ffffff;background-color:#222222;border-color:#222222;}
body.kc-css-system .kc-css-541650 .content-button{text-align:center;}
body.kc-css-system .kc-css-541650 i{color:#51c672;padding-right:10px;}
body.kc-css-system .kc-css-541650{background:rgba(255, 255, 255, 0);border:1px solid #dddddd;padding:30px 40px 30px 40px;}
body.kc-css-system .kc-css-470515 .content-title{color:#222222;font-family:Montserrat;font-size:25px;font-weight:700;line-height:25px;text-transform:none;text-align:center;padding-bottom:15px;}
body.kc-css-system .kc-css-470515 .content-price{color:#222222;font-size:35px;font-weight:700;padding-top:15px;}
body.kc-css-system .kc-css-470515 .kc-pricing-price{font-family:Montserrat;text-align:center;}
body.kc-css-system .kc-css-470515 .content-currency{color:#666666;font-size:16px;font-weight:400;line-height:55px;font-family:Montserrat;padding-right:15px;}
body.kc-css-system .kc-css-470515 .kc-pricing-price span.content-duration{color:#222222;font-size:18px;font-weight:700;}
body.kc-css-system .kc-css-470515 .content-desc li{color:#666666;font-family:Catamaran;font-size:17px;font-weight:400;line-height:18px;text-align:center;}
body.kc-css-system .kc-css-470515 .content-button a{color:#222222;background-color:#ffffff;font-size:16px;line-height:25px;font-weight:600;text-transform:none;width:100%;border:2px solid #ED7D31;border-radius:30px 30px 30px 30px;padding-right:60px;padding-left:60px;margin-top:10px;margin-bottom:15px;margin-left:-5px;}
body.kc-css-system .kc-css-470515 .content-button a:hover{color:#ffffff;background-color:#222222;border-color:#222222;}
body.kc-css-system .kc-css-470515 .content-button{text-align:center;}
body.kc-css-system .kc-css-470515 i{color:#51c672;padding-right:10px;}
body.kc-css-system .kc-css-470515{background:rgba(255, 255, 255, 0);border:1px solid #dddddd;padding:30px 40px 30px 40px;}
body.kc-css-system .kc-css-546832 .content-title{color:#222222;font-family:Montserrat;font-size:25px;font-weight:700;line-height:25px;text-transform:none;text-align:center;padding-bottom:15px;}
body.kc-css-system .kc-css-546832 .content-price{color:#222222;font-size:35px;font-weight:700;padding-top:15px;}
body.kc-css-system .kc-css-546832 .kc-pricing-price{font-family:Montserrat;text-align:center;}
body.kc-css-system .kc-css-546832 .content-currency{color:#666666;font-size:16px;font-weight:400;line-height:55px;font-family:Montserrat;padding-right:15px;}
body.kc-css-system .kc-css-546832 .kc-pricing-price span.content-duration{color:#222222;font-size:18px;font-weight:700;}
body.kc-css-system .kc-css-546832 .content-desc li{color:#666666;font-family:Catamaran;font-size:17px;font-weight:400;line-height:18px;text-align:center;}
body.kc-css-system .kc-css-546832 .content-button a{color:#222222;background-color:#ffffff;font-size:16px;line-height:25px;font-weight:600;text-transform:none;width:100%;border:2px solid #ED7D31;border-radius:30px 30px 30px 30px;padding-right:60px;padding-left:60px;margin-top:10px;margin-bottom:15px;margin-left:-5px;}
body.kc-css-system .kc-css-546832 .content-button a:hover{color:#ffffff;background-color:#222222;border-color:#222222;}
body.kc-css-system .kc-css-546832 .content-button{text-align:center;}
body.kc-css-system .kc-css-546832 i{color:#51c672;padding-right:10px;}
body.kc-css-system .kc-css-546832{background:rgba(255, 255, 255, 0);border:1px solid #dddddd;padding:30px 40px 30px 40px;}
body.kc-css-system .kc-css-856953{z-index:2;}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-541650{margin-bottom:20px;padding-right:40px;padding-left:40px;}
body.kc-css-system .kc-css-470515{margin-bottom:20px;padding-right:40px;padding-left:40px;}
body.kc-css-system .kc-css-546832{margin-bottom:20px;padding-right:40px;padding-left:40px;}
body.kc-css-system .kc-css-856953{display:none;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-110769{padding-top:60px;padding-bottom:60px;}
body.kc-css-system .kc-css-731184{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-541650 .content-title{text-align:center;}
body.kc-css-system .kc-css-541650 .kc-pricing-price{display:block;}
body.kc-css-system .kc-css-541650 .content-desc li{text-align:center;}
body.kc-css-system .kc-css-541650 .content-button{text-align:center;}
body.kc-css-system .kc-css-541650 .content-button a{width:207px;}
body.kc-css-system .kc-css-227325{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-470515 .content-title{text-align:center;}
body.kc-css-system .kc-css-470515 .kc-pricing-price{display:block;}
body.kc-css-system .kc-css-470515 .content-desc li{text-align:center;}
body.kc-css-system .kc-css-470515 .content-button{text-align:center;}
body.kc-css-system .kc-css-470515 .content-button a{width:207px;}
body.kc-css-system .kc-css-499934{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-546832 .content-title{text-align:center;}
body.kc-css-system .kc-css-546832 .kc-pricing-price{display:block;}
body.kc-css-system .kc-css-546832 .content-desc li{text-align:center;}
body.kc-css-system .kc-css-546832 .content-button{text-align:center;}
body.kc-css-system .kc-css-546832 .content-button a{width:207px;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'native';src:url(../../assets/fonts/native.eot?3hn4ip);src:url('../../assets/fonts/native.eot?3hn4ip#iefix') format('embedded-opentype'),url(../../assets/fonts/native.ttf?3hn4ip) format('truetype'),url(../../assets/fonts/native.woff?3hn4ip) format('woff'),url('../../assets/fonts/native.svg?3hn4ip#native') format('svg');font-weight:400;font-style:normal;}

</style>



// WEBPACK FOOTER //
// src/components/Blocks/Comparison.vue